import RankingStat from '../../entities/RankingStat.js';
import RankingScopeContext from '../../enums/RankingScopeContext.js';
import BattingRankingStats from '../../enums/BattingRankingStats.js';
import PitchingRankingStats from '../../enums/PitchingRankingStats.js';
import NumberFormatter from '../../formatters/NumberFormatter.js';
import SelectiveRankingStatCalculatorBase from './SelectiveRankingStatCalculatorBase.js';

class OnBasePlusSluggingStatCalculator extends SelectiveRankingStatCalculatorBase {
    constructor(context, numberFormatter) {
        if (typeof(numberFormatter) !== 'undefined' && !(numberFormatter instanceof NumberFormatter)) {
            throw new TypeError('numberFormatter must be an instance inheriting from NumberFormatter class');
        }
        if (!context || typeof(context) !== 'string') {
            throw new TypeError('context must be an non empty string');
        }
        if (![RankingScopeContext.Pitching.key, RankingScopeContext.Batting.key].find(s => s === context)) {
            throw new Error(`type of context ${context} in not supported, only ${RankingScopeContext.Pitching.key} and ${RankingScopeContext.Batting.key} are supported`);
        }

        const isPitchingContext = context === RankingScopeContext.Pitching.key;
        super([
            isPitchingContext ? PitchingRankingStats.OnBasePlusSlugging: BattingRankingStats.OnBasePlusSlugging
        ]);

        this.dependencies = isPitchingContext
            ? [PitchingRankingStats.OnBaseAgainst, PitchingRankingStats.SluggingPercentage]
            : [BattingRankingStats.OnBasePercentage, BattingRankingStats.SluggingPercentage];
        this.numberFormatter = numberFormatter || new NumberFormatter(3);
    }

    listDependencies(parameter) {
        // TODO - maybe concat ?
        return this.dependencies;
    }

    calculateStat(parameter, dependencies) {
        const obp = dependencies[0];
        const slg = dependencies[1];
        if (
            (!obp || obp.isEmpty())
            && (!slg || slg.isEmpty())
        ) {
            return null;
        }

        const obpValue = (!obp || obp.isEmpty()) ? 0 : obp.value;
        const slgValue = (!slg || slg.isEmpty()) ? 0 : slg.value;
        const obpWeight = (!obp || obp.isEmpty()) ? 0 : obp.weight;
        const slgWeight = (!slg || slg.isEmpty()) ? 0 : slg.weight;

        // TODO - weight should be the same for both, otherwise we will need to calculate it with common denominator
        return RankingStat.fromParameter(
            parameter, this.numberFormatter.format(
                obpValue + slgValue
            ), slgWeight + obpWeight
        );
    }
}

export default OnBasePlusSluggingStatCalculator;